import { useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import { Box } from '@mui/material';
import Grid from '@mui/material/Grid2';
import { isTokenValid } from '../../utils/Auth';
import { bodyWidth } from '../../utils/Style';
import { LoginForm } from './LoginForm';
import { RegisterForm } from './RegisterForm';
import { GenericHelmet } from '../../components/Helmet/GenericHelmet';
import { useLocalizedText } from '../../hooks/useLocalizedText';

export const LoginPage = () => {
  const t = useLocalizedText();

  const navigate = useNavigate();

  useEffect(() => {
    if (isTokenValid()) {
      navigate('/account');
    }
  }, []);

  const itemSize = {
    xs: 12,
    lg: 6,
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        alignItems: 'center',
      }}
    >
      <GenericHelmet title={t('login.login_register')} />

      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          width: bodyWidth,
          py: 3,
          px: 1.5,
          gap: 1.5,
          boxSizing: 'border-box',
        }}
      >
        <Grid container spacing={{ xs: 3 }} width='100%'>
          <Grid size={itemSize}>
            <LoginForm />
          </Grid>
          <Grid size={itemSize}>
            <RegisterForm />
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};
